export default class FrameService {
    on(): void {
        document.getElementById('main-header').classList.remove('hidden');
        document.getElementById('main-page').classList.remove('hidden');
    }

    off(): void {
        document.getElementById('main-header').classList.add('hidden');
        document.getElementById('main-page').classList.add('hidden');
    }

    offFooter(): FrameService {
        document.getElementById('main_footer').style.display = 'none';

        return this;
    }

    onFooter(): FrameService {
        document.getElementById('main_footer').style.display = 'block';

        return this;
    }
}
